/*
 * Delete-coupons.ts
 * Description: Includes the declaration
 * of the function for deleting a coupon
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Delete a coupon
 *
 * @return {Object} Promise - updated coupon
 * @param {String} slug - id of a restaurant
 * @param {Number} couponId - id of the coupon to be deleted
 */
export function deleteCoupons(slug: string, couponId: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/coupons/' + couponId,
            method: 'delete',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
